export default __webpack_public_path__ + "static/media/clients.85f02bfc.svg";